import { ChevronLeft } from 'lucide-react'

type Props = {
  confirmedCount: number
  totalCount:     number
  onBack:         () => void
}

export function UnpackMasthead({ confirmedCount, totalCount, onBack }: Props) {
  const pct = totalCount > 0 ? Math.round((confirmedCount / totalCount) * 100) : 0

  return (
    <header className="mb-5">
      <button
        onClick={onBack}
        className="mb-4 flex items-center gap-1 py-1 text-[13px] font-medium text-ink-muted"
      >
        <ChevronLeft className="h-[14px] w-[14px]" strokeWidth={1.7} />
        Back
      </button>

      <div className="pb-4 border-b border-border-sand">
        <div className="text-[10px] uppercase tracking-[0.18em] text-ink-muted font-medium mb-1">
          Just got back
        </div>
        <h1 className="font-serif text-[30px] font-normal tracking-[-0.015em] text-ink leading-[1.05]">
          What did you <em className="italic">bring home?</em>
        </h1>
        <p className="font-serif text-[13px] italic text-ink-muted mt-1 leading-[1.4]">
          Tap each item you actually bought. Skip the rest.
        </p>
      </div>

      <div className="mt-4">
        <div className="flex items-baseline justify-between mb-1">
          <span className="font-serif text-[11px] italic text-ink-muted">
            {confirmedCount} of {totalCount} confirmed
          </span>
          <span className="text-[10px] uppercase tracking-[0.08em] font-medium text-ink-muted">
            {pct}%
          </span>
        </div>
        <div className="h-[6px] overflow-hidden rounded-[3px] bg-[#F0EBE0]">
          <div
            className="h-full rounded-[3px] bg-forest transition-[width] duration-300"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
    </header>
  )
}
